import {Container,Navbar,Nav,NavDropdown } from 'react-bootstrap';
import logo from '../media/logo.jpg';
import { IoPhonePortraitOutline } from "react-icons/io5";
import '../styles/navbar.css';
import React, { useState } from 'react';

function NNavbar(){
  const [showDropdown, setShowDropdown] = useState(false);

    return(
         <header className="home-header">
      <Navbar expand="md" bg="light" className="py-2 px-3 navbar" fixed="top">
        <Container fluid>
          {/* Logo */}
          <Navbar.Brand href="#home">
            <a href="/"><img src={logo} alt="Logo" className="home-logo" style={{ height: '50px' }} /></a>
          </Navbar.Brand>

          {/* Toggle for Mobile */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          {/* Collapsible Nav Items */}
<Navbar.Collapse id="basic-navbar-nav" className="justify-content-between navitems">
      <Nav className="me-auto">
        <Nav.Link href="/">Home</Nav.Link>
        <Nav.Link href="/about">About Us</Nav.Link>

        <NavDropdown
          title="Services"
          id="basic-nav-dropdown"
          show={showDropdown}
          onMouseEnter={() => setShowDropdown(true)}
          onMouseLeave={() => setShowDropdown(false)}
          onClick={() => window.location.href = '/services'} // Go to /services on click
        >
          <NavDropdown.Item href="/service/dataanalyticsandbi">Data Analytics & Business Intelligence</NavDropdown.Item>
          <NavDropdown.Item href="/service/accountingandbookkeeping">Accounting & Bookkeeping Services</NavDropdown.Item>
          <NavDropdown.Item href="/service/vatandcorporatetax">VAT & Corporate Tax Compliance</NavDropdown.Item>
          <NavDropdown.Item href="/service/amlcompliance">AML & Compliance Services</NavDropdown.Item>
          <NavDropdown.Item href="/service/cfosupport">CFO Support Services</NavDropdown.Item>
          <NavDropdown.Item href="/service/payroll">Payroll Management</NavDropdown.Item>
          <NavDropdown.Item href="/service/interalaudit">Internal Audit Services</NavDropdown.Item>
          <NavDropdown.Item href="/service/auditliaison">Audit Liaison & Final Reports</NavDropdown.Item>
        </NavDropdown>
      </Nav>

      <div className="d-flex justify-content-end">
        <button className="contact-btn" onClick={() => window.location.href = '/contactus'}>
          <span>Contact us</span>
          <div className="icon-circle">
            <IoPhonePortraitOutline />
          </div>
        </button>
      </div>
    </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
    )
}

export default NNavbar;